module.exports = __webpack_public_path__ + "static/img/bg.25825f3e.png";